import { render, staticRenderFns } from "./OrderTaking.vue?vue&type=template&id=1c9fbf6c"
import script from "./OrderTaking.vue?vue&type=script&lang=js"
export * from "./OrderTaking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports